import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { getApiBaseUrl } from "../../config/api";
import { selectAuthApiKey } from "../authSelectors";
import type { RootState } from "../../types/store";
import { apiFetch } from "../../utils/http/readJsonResponse";

export const appBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
  fetchBaseQuery({
    baseUrl: getApiBaseUrl(),
    fetchFn: apiFetch,
    prepareHeaders: (headers, { getState }) => {
      const apiKey = selectAuthApiKey(getState() as RootState);
      if (apiKey) {
        headers.set("Authorization", `Token ${apiKey}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  });
